export const scrollToTarget = (targetOptions: {
    target: HTMLElement;
    additionalOffsetTop?: number;
    smooth?: boolean;
}) => {
    let additionalScrollTop = 0;
    if (targetOptions.additionalOffsetTop !== undefined)
        additionalScrollTop = targetOptions.additionalOffsetTop;
    const targetRects = targetOptions.target.getBoundingClientRect();
    const isBrowserIE11 = window.navigator.userAgent.indexOf("Trident/") !== -1;
    if (targetOptions.target.closest("ux-modal") !== null) {
        if (isBrowserIE11) targetOptions.target.scrollIntoView();
        else
            targetOptions.target.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        return;
    }
    if (isBrowserIE11) {
        window.scrollTo(
            window.pageXOffset,
            targetRects.top + window.pageYOffset - additionalScrollTop
        );
        return;
    }
    if (targetOptions.smooth === false) {
        window.scrollTo({
            left: window.scrollX,
            top: targetRects.top + window.scrollY - additionalScrollTop,
        });
    } else {
        window.scrollTo({
            left: window.scrollX,
            top: targetRects.top + window.scrollY - additionalScrollTop,
            behavior: "smooth",
        });
    }
};
